import { render, staticRenderFns } from "./score-board.vue?vue&type=template&id=511666ec&scoped=true&"
import script from "./score-board.vue?vue&type=script&lang=js&"
export * from "./score-board.vue?vue&type=script&lang=js&"
import style0 from "./score-board.vue?vue&type=style&index=0&id=511666ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511666ec",
  null
  
)

export default component.exports